import HDCevents from "../../assets/HDCevents.jpg";
import OLDportfolio from "../../assets/OLDportfolio.jpg";
import MooseFilm from "../../assets/MooseFilm.jpg";
import AttendanceList from "../../assets/AttendanceList.jpg";
import Work5 from "../../assets/work5.jpg";
import Instagram from "../../assets/Instagram.jpg";
import Calculator from "../../assets/calculator.png";
import Finance_System from "../../assets/Finance_System.jpg";
import Tormenta20 from "../../assets/tormenta20.png"
import Whatsapp from "../../assets/logo-whats.png"

export const projectsData = [
    {
      id: 1,  
      image: Finance_System,
      title: "Sistema de gestão financeira",
      category: "Backend",
      demo: "https://financial-management-system-eight.vercel.app",
      githublink: "https://github.com/VictorAsz/financial-management-system",
    },
    {
      id: 2,
      image: Instagram,
      title: "Clone do Instagram",
      category: "Backend",
      demo: null,
      githublink: "https://github.com/VictorAsz/Instagram-clone",
    },
        {
      id: 3,
      image: Tormenta20,
      title: "Enciclopédia de Tormenta20",
      category: "Frontend",
      demo: "https://enciclopedia-tormenta20.vercel.app/",
      githublink: "https://github.com/VictorAsz/CRUDPHP-BDmySQL",
    },
    // {
    //   id: 4,
    //   image: HDCevents,
    //   title: "Gerenciador de Eventos",
    //   category: "Backend",
    //   demo: null,
    //   githublink: "https://github.com/VictorAsz/HDCevents",
    // },
    {
      id: 5,
      image: OLDportfolio,
      title: "Portfólio Antigo",
      category: "Frontend",
      demo: "https://personal-portfolio-mu-puce.vercel.app/",
      githublink: "https://github.com/VictorAsz/Personal-Portfolio",
    },
    {
      id: 6,
      image: MooseFilm,
      title: "Buscador de Filmes",
      category: "Frontend",
      demo: "https://moose-film.vercel.app/",
      githublink: "https://github.com/VictorAsz/MooseFilm",
    },
    {
      id: 7,
      image: AttendanceList,
      title: "Lista de Chegada",
      category: "Frontend",
      demo: "https://lista-de-presen-a-rockseat-discover.vercel.app/",
      githublink: "https://github.com/VictorAsz/AttendanceList",
    },
    {
      id: 8,
      image: Calculator,
      title: "Calculadora",
      category: "Frontend",
      demo: "https://codepen.io/Drayuuta/pen/JjzBbWO",
      githublink: "https://github.com/VictorAsz/Calculadora",
    },
    // {
    //   id: 9,
    //   image: Work5,
    //   title: "PHP CRUD MySQL and Bootstrap",
    //   category: "Backend",
    //   demo: null,
    //   githublink: "https://github.com/VictorAsz/CRUDPHP-BDmySQL",
    // },
        {
      id: 9,
      image: Work5,
      title: "Sistema de Hamburgueria",
      category: "Frontend",
      demo: "https://burger-commerce-beige.vercel.app/",
      githublink: "https://github.com/VictorAsz/BurgerCommerce",
    },
    {
      id: 10,
      image: Whatsapp,
      title: "Sistema de Hamburgueria",
      category: "Backend",
      demo: "https://burger-commerce-beige.vercel.app/",
      githublink: "https://github.com/VictorAsz/BurgerCommerce",
    },


  ];
  
  
  export const projectsNav = [
    {
        name: "All",
    },
    {
        name: "Frontend",
    },
    {
        name: "Backend",
    },
  
  ]